import { SelectOption } from '@billing/app/models'

export interface CommodityFormProfile {
  id?: number
  code: string
  catalogueId: number
  parentCommodityId?: number | null
  name: string
  description?: string | null
  height?: number | string
  length?: number | string
  width?: number | string
  weight?: number | string
  classDefinition?: string
  packageIds?: SelectOption[]
  instructions?: string
  attributes: CommodityAttributeFormProfile[]
  isActive: boolean
  isSelectable: boolean
}

export interface CommodityAttributeFormProfile {
  name: string
  value: string
}

export const defaultValues: CommodityFormProfile = {
  name: '',
  code: '',
  catalogueId: 0,
  description: '',
  attributes: [],
  packageIds: [],
  isActive: true,
  isSelectable: true,
  height: '',
  length: '',
  width: '',
  weight: '',
  instructions: '',
  classDefinition: '',
}

export const defaultAttributeValues: CommodityAttributeFormProfile = {
  name: '',
  value: '',
}
